<template>
  <main>
    <section class="hero" aria-labelledby="page-title">
      <div class="section__inner hero__inner">
        <h2 id="page-title">교육/워크숍</h2>
        <p><strong>ICI Korea </strong> Recognizing Competency World-Wide</p>

      </div>
    </section>

    <!-- Tabs -->
    <section aria-label="About Navigation" class="about-tabs">
      <div class="section__inner">
        <nav class="tabs">
          <button :class="{ active: activeTab === 'training' }" @click="activeTab = 'training'">교육안내</button>
        </nav>
      </div>
    </section>

    <!-- 탭 내용 -->
    <Training v-if="activeTab === 'training'" />
    <!-- <Cicp v-else-if="activeTab === 'cicp'" /> -->
  </main>
</template>

<script setup>
import { ref } from "vue"

// 탭별 컴포넌트 import

import Training from "../training-page/Training.vue"

const activeTab = ref("training") // 기본 탭: 협회 소개
</script>

<style scoped>
.about {
  display: flex;
  flex-direction: column;
  /* gap: 40px; */
}

.section__inner {
  max-width: 1200px;
  margin-inline: auto;
  padding: 20px 16px;
}

/* Hero */
.hero {
  background:
    linear-gradient(rgba(13, 6, 20, .65), rgba(13, 6, 20, .65)),
    /* url('/src/assets/sampleabout.jpg') center/cover no-repeat; */
    url('/src/assets/traingMain.jpeg') center/70% no-repeat;
  color: #fff;
}

.hero__inner {
  padding: 130px 16px;
  text-align: center;
}

.hero h2 {
  font-family: 'Noto Sans KR', sans-serif;
  font-weight: 700;
  color: #fff;
  font-size: 40px;
  text-align: center;
  letter-spacing: -1px;
  line-height: 1.3;
}

.hero p {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  margin-top: 12px;
  letter-spacing: -0.3px;
  line-height: 1.6;
}

.hero p strong{
  font-size: 1.225rem;
  font-weight: 700;
}

@media (max-width: 600px) {
  .hero__inner {
    padding: 50px 16px;
  }
}


.tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  border-bottom: 2px solid #e5e5e5;
  padding: 0.5rem 0;
}

button {
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #444;
  position: relative;
  font-size: 1.1rem;
}

button.active {
  color: var(--main-color);
  font-weight: 600;
}

button.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--main-color);
}
</style>
